import React from 'react';
import { Box } from '@cko/primitives';

import { Notification } from '../../types';
import { ErrorView } from './ErrorView';
import { LoadingView } from './LoadingView';
import { ListView } from './ListView';
import { EmptyView } from './EmptyView';
import { Heading, Wrapper } from './NotificationsList.styles';

export const NOTIFICATIONS_LIST_TEST_ID = 'notifications-in-navigation-list';

type Props = {
  closeList: () => void;
  isError: boolean;
  isLoading: boolean;
  notifications: Notification[];
};

export const NotificationsList = ({ closeList, isError, isLoading, notifications }: Props) => {
  const isEmpty = notifications.length === 0;

  return (
    <Wrapper>
      <Box padding="var(--layout-shoebox) var(--layout-shoebox) var(--layout-spoon)">
        <Heading data-testid={NOTIFICATIONS_LIST_TEST_ID}>Notifications</Heading>
      </Box>
      {(() => {
        switch (true) {
          case isError:
            return <ErrorView />;
          case isLoading:
            return <LoadingView />;
          case isEmpty:
            return <EmptyView />;
          default:
            return <ListView closeList={closeList} notifications={notifications} />;
        }
      })()}
    </Wrapper>
  );
};
